import type { NextPage } from 'next'
import Head from 'next/head'
import { useState } from 'react'
import Pixel from 'common/seo/pixel'
import { Simulacao } from 'src/views'

const SimulacaoPage: NextPage = () => {
  return (
    <>
      <Head>
        <meta charSet="UTF-8" />

        <title>Empréstimo pessoal sem sair de casa - Crédito One</title>

        <meta
          property="og:description"
          content="Empréstimos em até 18x, rápido e sem garantias. Faça uma simulação agora e descubra a parcela ideal para você."
        />
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="pt_BR" />
        <meta property="og:site_name" content="Crédito One" />
        <meta
          property="og:title"
          content="Empréstimo pessoal sem sair de casa - Crédito One"
        />
        <meta
          name="description"
          content="Empréstimos em até 18x, rápido e sem garantias. Faça uma simulação agora e descubra a parcela ideal para você."
        />
        <meta
          property="og:image"
          content="https://uploads-ssl.webflow.com/5fb18514177e609c5101c5b2/61aa78267b898128a13bbb31_open%20graph.png"
        />
        <link rel="icon" href="/favicon.ico" />
      </Head>
      <Simulacao />
    </>
  )
}

export default SimulacaoPage
